import Roles from '@/auth/roles';
import teamModel from '@/entities/team/team-model';
import teamPager from '@/entities/team/team-pager';
import clubTeamService from '@/entities/club/club-team-list/club-team-list-service';
import categoryService from '@/entities/category/category-service';
import clubService from '@/entities/club/club-service';
import playerService from '@/entities/player/player-service';
import clubModel from '@/entities/club/club-model';
/* eslint-disable */
export default {
  namespaced: true,

  state: {
    loading: false,
    list: [],
    club: clubModel.default(),
    pager: teamPager.build(),
    model: teamModel.default(),
    options: {},
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    options: state => state.options,
    club: (
      state,
      getters,
      rootState,
      rootGetters
    ) => rootState.entities.club.model,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id,
        roles.clubManager.id, // NEW!!
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamViewer.id,
        roles.teamEditor.id,
        roles.clubManager.id, // NEW!!

      ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || teamModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = teamPager.build();
      state.model = teamModel.default();
      state.options = {};
    },

    ADD_OPTIONS(state, payload) {
      state.options = Object.assign({}, state.options, { [payload.key]: payload.options });
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);

      return clubTeamService
        .find(id).then((model) => {
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
      })
    },

    new({ commit }) {
      commit('MODEL', null);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);

      return clubTeamService.find(id).then((model) => {
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
        })
    },

    save({ getters, commit, rootGetters, dispatch }) {
      commit('LOADING', true);

      return clubTeamService
        .save(getters.model, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            'Team saved successfully!',
            { root: true }
          );

          commit('LOADING', false);
        })
      
    },

    destroy({ commit, dispatch, rootGetters }, id) {
      commit('LOADING', true);

      return clubTeamService
        .destroy(id, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            'Team deleted successfully!',
            { root: true }
          );
        })
        .then(() => dispatch('list'))
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ getters, commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);

      console.log("<------- ROOT STATE");
      
      var clubId = getters.club.id
      return clubTeamService
        .list(clubId)
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    },

    loadOptions({ commit, dispatch }) {
      categoryService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'categories', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      clubService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'clubs', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      playerService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'players', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/club/club-team-list/club-team-list-store.js